module.exports = __webpack_public_path__ + "img/prolongation-bg-2.5017654.png";